import * as React from 'react';

const AuthenticityDiamondMultichome16Dark = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { fill: "none", viewBox: "0 0 16 16", width: 16, height: 16, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "#449DA9",
    d: "M6.504 13.6 1.173 7.59a2 2 0 0 1-.004-2.65l2.234-2.535a2 2 0 0 1 1.5-.678h6.194a2 2 0 0 1 1.5.678l2.235 2.536a2 2 0 0 1-.005 2.649l-5.33 6.01a2 2 0 0 1-2.993 0m4.452-9.186c-.056-.476-.748-.476-.804 0l-.12 1.003a.405.405 0 0 1-.354.355l-1.003.119c-.477.056-.477.748 0 .805l1.003.119a.405.405 0 0 1 .354.354l.12 1.003c.056.477.748.477.804 0l.12-1.003a.405.405 0 0 1 .354-.354l1.003-.12c.476-.056.476-.748 0-.804l-1.003-.12a.405.405 0 0 1-.355-.354z"
  }
));
AuthenticityDiamondMultichome16Dark.Size = 16;
AuthenticityDiamondMultichome16Dark.Title = "AuthenticityDiamondMultichome";

export { AuthenticityDiamondMultichome16Dark as default };
